import { useEffect, useState } from "react";
import api from "@/lib/api";

const TONES = ["Professional", "Enthusiastic", "Confident"];

export default function CoverLetter() {
  const [jobs, setJobs] = useState([]);
  const [jobId, setJobId] = useState("");
  const [tone, setTone] = useState("Professional");
  const [loading, setLoading] = useState(false);
  const [letter, setLetter] = useState(null);

  useEffect(() => {
    api.get("/jobs/matches?limit=30").then((r) => {
      setJobs(r.data);
      if (r.data[0]) setJobId(r.data[0].job_id);
    });
  }, []);

  const generate = async () => {
    if (!jobId) return;
    setLoading(true);
    try {
      const r = await api.post("/cover-letter", { job_id: jobId, tone });
      setLetter(r.data);
    } catch (e) { alert(e.response?.data?.detail || "Failed"); }
    finally { setLoading(false); }
  };

  return (
    <div className="space-y-6 max-w-4xl" data-testid="cover-letter-page">
      <div className="jr-card">
        <div className="grid md:grid-cols-3 gap-3">
          <select value={jobId} onChange={(e) => setJobId(e.target.value)} className="jr-input" data-testid="cl-job-select">
            <option value="" className="bg-[#161635]">Select a job...</option>
            {jobs.map((j) => <option key={j.job_id} value={j.job_id} className="bg-[#161635]">{j.title} @ {j.company}</option>)}
          </select>
          <select value={tone} onChange={(e) => setTone(e.target.value)} className="jr-input" data-testid="cl-tone-select">
            {TONES.map(t => <option key={t} className="bg-[#161635]">{t}</option>)}
          </select>
          <button onClick={generate} disabled={loading || !jobId} className="jr-btn-primary" data-testid="cl-generate-btn">
            {loading ? "Generating..." : "Generate Cover Letter"}
          </button>
        </div>
      </div>

      {letter && (
        <div className="jr-card jr-fade-in" data-testid="cl-result">
          <div className="text-xs text-zinc-400 mb-2">Subject</div>
          <div className="text-white font-semibold mb-4">{letter.subject}</div>
          <div className="whitespace-pre-wrap text-zinc-200 text-sm leading-relaxed">
            {letter.greeting}{"\n\n"}{letter.body}{"\n\n"}{letter.closing}
          </div>
        </div>
      )}
    </div>
  );
}
